import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Zap, ShieldCheck, Wind, Flame, HeartHandshake } from 'lucide-react';
import { scrollToComprar } from '../utils';
const items = [{
  icon: Sparkles,
  title: 'Mejor digestión',
  desc: 'Heces firmes y sin malos olores.'
}, {
  icon: Zap,
  title: 'Más energía',
  desc: 'Vitalidad y ganas de jugar.'
}, {
  icon: ShieldCheck,
  title: 'Menos alergias',
  desc: 'Adiós a la picazón constante.'
}, {
  icon: Wind,
  title: 'Pelo más brillante',
  desc: 'Manto suave y radiante.'
}, {
  icon: Flame,
  title: 'Menos inflamación',
  desc: 'Articulaciones más sanas.'
}, {
  icon: HeartHandshake,
  title: 'Mejor calidad de vida',
  desc: 'Más años, más felices.'
}];
export function Transformations() {
  return <section className="py-12 md:py-16 px-4 bg-cream" data-id="element-218">
      <div className="max-w-5xl mx-auto" data-id="element-219">
        <div className="text-center mb-8 md:mb-10" data-id="element-220">
          <span className="inline-block bg-accent/10 text-accent text-sm font-bold px-3 py-1 rounded-full mb-3" data-id="element-221">
            RESULTADOS REALES
          </span>
          <h2 className="font-display text-3xl md:text-4xl font-bold text-primary" data-id="element-222">
            Lo que puede cambiar en tu perro
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-5" data-id="element-223">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.06
        }} onClick={scrollToComprar} className="bg-white p-5 md:p-6 rounded-2xl border border-cream-dark shadow-sm flex flex-col items-center text-center gap-2 cursor-pointer hover:-translate-y-1 hover:shadow-md transition" data-id="element-224">
              <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-1" data-id="element-225">
                <item.icon className="text-primary" size={22} data-id="element-226" />
              </div>
              <h3 className="font-bold text-primary text-base md:text-lg leading-tight" data-id="element-227">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-brown-light leading-snug" data-id="element-228">
                {item.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}